import { Check, X } from 'lucide-react';
import type { CustomLlmCapabilities } from './types';

const LABELS: Record<keyof CustomLlmCapabilities, string> = {
  chat: 'Chat',
  tools: 'Tool calling',
  json_mode: 'JSON mode',
  streaming: 'Streaming',
  vision: 'Vision',
  embedding: 'Embedding',
  rerank: 'Rerank',
  audio_transcription: 'STT',
  audio_speech: 'TTS',
  realtime_audio: 'Realtime',
};

interface Props {
  capabilities: CustomLlmCapabilities;
  compact?: boolean;
}

export function CapabilityChecklist({ capabilities, compact }: Props): JSX.Element {
  const keys = Object.keys(LABELS) as Array<keyof CustomLlmCapabilities>;
  return (
    <ul className={`grid ${compact ? 'grid-cols-5 gap-1' : 'grid-cols-2 gap-2 sm:grid-cols-5'}`}>
      {keys.map((k) => {
        const enabled = capabilities[k];
        return (
          <li
            key={k}
            className={`flex items-center gap-1.5 rounded-md border px-2 py-1 text-xs ${
              enabled
                ? 'border-emerald-300 bg-emerald-50 text-emerald-700 dark:border-emerald-700 dark:bg-emerald-950 dark:text-emerald-300'
                : 'border-zinc-200 bg-zinc-50 text-zinc-500 dark:border-zinc-700 dark:bg-zinc-900 dark:text-zinc-400'
            }`}
            title={enabled ? `${LABELS[k]} supportato` : `${LABELS[k]} non supportato`}
          >
            {enabled ? <Check className="h-3 w-3" /> : <X className="h-3 w-3" />}
            <span className="truncate">{LABELS[k]}</span>
          </li>
        );
      })}
    </ul>
  );
}
